import { render, staticRenderFns } from "./adminReportsPage.html?vue&type=template&id=297cab59&"
import script from "./adminReportsPage.vue?vue&type=script&lang=js&"
export * from "./adminReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports